import { useEffect, useState } from 'react';

/** hh:mm:ss since `since`, ticking exactly on each second (the clock-face way, not every few seconds). */
export function RecTimer({ since }: { since: string }) {
  const start = Date.parse(since);
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    let id = 0;
    const tick = () => {
      setNow(Date.now());
      // Wake just after the next whole second of recording time, so the digits never skip or stall.
      id = window.setTimeout(tick, 1000 - ((Date.now() - start) % 1000) + 5);
    };
    tick();
    return () => clearTimeout(id);
  }, [start]);
  const s = Math.max(0, Math.floor((now - start) / 1000));
  const pad = (n: number) => String(n).padStart(2, '0');
  return (
    <span className="rec-timer" aria-label="Recording time">
      {pad(Math.floor(s / 3600))}:{pad(Math.floor((s % 3600) / 60))}:{pad(s % 60)}
    </span>
  );
}
